"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorMappings = void 0;

var _rootColors = _interopRequireDefault(require("../0_rootStyleAttributes/rootColors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This file provides mappings from the color pallet to specific usages by category.
 * It does not provide any styling, and should not - it is just for mapping.
 * The theme.js file then consumes this file to create the root application theme
 */
var colorMappings = {
  // ================================================================================================================ //
  // Color Themes                                                                                                     //
  //    - prefixed with 'c_'                                                                                          //
  //    - followed by use grouping, i.e. 'clickable_'                                                                 //
  //    - then color grouping, i.e. 'primaryGhost_'                                                                   //
  //    - the last piece is composed of state + background/foreground, where applicable, i.e. 'HoverForeground'       //
  // Yes, these names are verbose, but this should help with clarity of intended use                                  //
  //                                                                                                                  //
  // When you do need to use modifiers such as light and dark, let's give the following a shot                        //
  //    - veryLight                                                                                                   //
  //    - medLight                                                                                                    //
  //    - light                                                                                                       //
  //    - <no modifier>                                                                                               //
  //    - dark                                                                                                        //
  //    - medDark                                                                                                     //
  //    - veryDark                                                                                                    //
  //                                                                                                                  //
  // Each Pallet section has the following sub-sections                                                               //
  //    - clickable
  // ================================================================================================================ //
  // ======= //
  // Primary //
  // ========//
  // WIP
  // ###################################### //
  // ## Clickable/Interactive components ## //
  // ###################################### //
  // disabled button-type things
  c_clickable_disabled_background: _objectSpread({}, _rootColors.default._greyColor100),
  c_clickable_disabled_border: _objectSpread({}, _rootColors.default._greyColor100),
  c_clickable_disabled_text: _objectSpread({}, _rootColors.default._greyColor600),
  // primary button-like things
  c_clickable_primary_background: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primary_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primary_text: _objectSpread({}, _rootColors.default._white),
  c_clickable_primary_hover_background: _objectSpread({}, _rootColors.default._primaryColor700),
  c_clickable_primary_hover_border: _objectSpread({}, _rootColors.default._primaryColor700),
  c_clickable_primary_hover_text: _objectSpread({}, _rootColors.default._white),
  c_clickable_primary_active_background: _objectSpread({}, _rootColors.default._primaryColor500),
  c_clickable_primary_active_border: _objectSpread({}, _rootColors.default._primaryColor500),
  c_clickable_primary_active_text: _objectSpread({}, _rootColors.default._white),
  // primaryGhost button-like things
  c_clickable_primaryGhost_background: _objectSpread({}, _rootColors.default._white),
  c_clickable_primaryGhost_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primaryGhost_text: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primaryGhost_hover_background: _objectSpread({}, _rootColors.default._primaryColor100),
  c_clickable_primaryGhost_hover_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primaryGhost_hover_text: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primaryGhost_active_background: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primaryGhost_active_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primaryGhost_active_text: _objectSpread({}, _rootColors.default._white),
  // primaryPseudo button-like things
  c_clickable_primaryPseudo_background: {
    value: 'transparent'
  },
  c_clickable_primaryPseudo_border: {
    value: 'transparent'
  },
  c_clickable_primaryPseudo_text: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primaryPseudo_hover_background: _objectSpread({}, _rootColors.default._primaryColor100),
  c_clickable_primaryPseudo_hover_border: _objectSpread({}, _rootColors.default._primaryColor100),
  c_clickable_primaryPseudo_hover_text: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primaryPseudo_active_background: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primaryPseudo_active_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_primaryPseudo_active_text: _objectSpread({}, _rootColors.default._white),
  // primaryLight button-like things
  c_clickable_primaryLight_background: _objectSpread({}, _rootColors.default._primaryColor100),
  c_clickable_primaryLight_border: _objectSpread({}, _rootColors.default._primaryColor100),
  c_clickable_primaryLight_text: _objectSpread({}, _rootColors.default._greyColor800),
  c_clickable_primaryLight_hover_background: _objectSpread({}, _rootColors.default._primaryColor300),
  c_clickable_primaryLight_hover_border: _objectSpread({}, _rootColors.default._primaryColor300),
  c_clickable_primaryLight_hover_text: _objectSpread({}, _rootColors.default._greyColor800),
  c_clickable_primaryLight_active_background: _objectSpread({}, _rootColors.default._primaryColor200),
  c_clickable_primaryLight_active_border: _objectSpread({}, _rootColors.default._primaryColor200),
  c_clickable_primaryLight_active_text: _objectSpread({}, _rootColors.default._greyColor800),
  // cta button-like things
  c_clickable_cta_background: _objectSpread({}, _rootColors.default._ctaColor600),
  c_clickable_cta_border: _objectSpread({}, _rootColors.default._ctaColor600),
  c_clickable_cta_text: _objectSpread({}, _rootColors.default._white),
  c_clickable_cta_hover_background: _objectSpread({}, _rootColors.default._ctaColor700),
  c_clickable_cta_hover_border: _objectSpread({}, _rootColors.default._ctaColor700),
  c_clickable_cta_hover_text: _objectSpread({}, _rootColors.default._white),
  c_clickable_cta_active_background: _objectSpread({}, _rootColors.default._ctaColor300),
  c_clickable_cta_active_border: _objectSpread({}, _rootColors.default._ctaColor300),
  c_clickable_cta_active_text: _objectSpread({}, _rootColors.default._white),
  // ctaGhost button-like things
  c_clickable_ctaGhost_background: _objectSpread({}, _rootColors.default._white),
  c_clickable_ctaGhost_border: _objectSpread({}, _rootColors.default._ctaColor600),
  c_clickable_ctaGhost_text: _objectSpread({}, _rootColors.default._ctaColor600),
  c_clickable_ctaGhost_hover_background: _objectSpread({}, _rootColors.default._ctaColor100),
  c_clickable_ctaGhost_hover_border: _objectSpread({}, _rootColors.default._ctaColor600),
  c_clickable_ctaGhost_hover_text: _objectSpread({}, _rootColors.default._ctaColor600),
  c_clickable_ctaGhost_active_background: _objectSpread({}, _rootColors.default._ctaColor600),
  c_clickable_ctaGhost_active_border: _objectSpread({}, _rootColors.default._ctaColor600),
  c_clickable_ctaGhost_active_text: _objectSpread({}, _rootColors.default._white),
  // no ctaPseudo at this point in time
  // info button-like things
  c_clickable_info_background: _objectSpread({}, _rootColors.default._infoColor600),
  c_clickable_info_border: _objectSpread({}, _rootColors.default._infoColor600),
  c_clickable_info_text: _objectSpread({}, _rootColors.default._white),
  c_clickable_info_hover_background: _objectSpread({}, _rootColors.default._infoColor700),
  c_clickable_info_hover_border: _objectSpread({}, _rootColors.default._infoColor700),
  c_clickable_info_hover_text: _objectSpread({}, _rootColors.default._white),
  c_clickable_info_active_background: _objectSpread({}, _rootColors.default._infoColor300),
  c_clickable_info_active_border: _objectSpread({}, _rootColors.default._infoColor300),
  c_clickable_info_active_text: _objectSpread({}, _rootColors.default._white),
  // infoGhost button-like things
  c_clickable_infoGhost_background: _objectSpread({}, _rootColors.default._white),
  c_clickable_infoGhost_border: _objectSpread({}, _rootColors.default._infoColor600),
  c_clickable_infoGhost_text: _objectSpread({}, _rootColors.default._infoColor600),
  c_clickable_infoGhost_hover_background: _objectSpread({}, _rootColors.default._infoColor100),
  c_clickable_infoGhost_hover_border: _objectSpread({}, _rootColors.default._infoColor600),
  c_clickable_infoGhost_hover_text: _objectSpread({}, _rootColors.default._infoColor600),
  c_clickable_infoGhost_active_background: _objectSpread({}, _rootColors.default._infoColor600),
  c_clickable_infoGhost_active_border: _objectSpread({}, _rootColors.default._infoColor600),
  c_clickable_infoGhost_active_text: _objectSpread({}, _rootColors.default._white),
  // warning button-like things
  c_clickable_warning_background: _objectSpread({}, _rootColors.default._warningColor600),
  c_clickable_warning_border: _objectSpread({}, _rootColors.default._warningColor600),
  c_clickable_warning_text: _objectSpread({}, _rootColors.default._greyColor800),
  c_clickable_warning_hover_background: _objectSpread({}, _rootColors.default._warningColor700),
  c_clickable_warning_hover_border: _objectSpread({}, _rootColors.default._warningColor700),
  c_clickable_warning_hover_text: _objectSpread({}, _rootColors.default._greyColor800),
  c_clickable_warning_active_background: _objectSpread({}, _rootColors.default._warningColor300),
  c_clickable_warning_active_border: _objectSpread({}, _rootColors.default._warningColor300),
  c_clickable_warning_active_text: _objectSpread({}, _rootColors.default._greyColor800),
  // danger button-like things
  c_clickable_danger_background: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_danger_border: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_danger_text: _objectSpread({}, _rootColors.default._white),
  c_clickable_danger_hover_background: _objectSpread({}, _rootColors.default._dangerColor700),
  c_clickable_danger_hover_border: _objectSpread({}, _rootColors.default._dangerColor700),
  c_clickable_danger_hover_text: _objectSpread({}, _rootColors.default._white),
  c_clickable_danger_active_background: _objectSpread({}, _rootColors.default._dangerColor300),
  c_clickable_danger_active_border: _objectSpread({}, _rootColors.default._dangerColor300),
  c_clickable_danger_active_text: _objectSpread({}, _rootColors.default._white),
  // dangerGhost button-like things
  c_clickable_dangerGhost_background: _objectSpread({}, _rootColors.default._white),
  c_clickable_dangerGhost_border: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_dangerGhost_text: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_dangerGhost_hover_background: _objectSpread({}, _rootColors.default._dangerColor100),
  c_clickable_dangerGhost_hover_border: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_dangerGhost_hover_text: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_dangerGhost_active_background: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_dangerGhost_active_border: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_dangerGhost_active_text: _objectSpread({}, _rootColors.default._white),
  // dangerPseudo button-like things
  c_clickable_dangerPseudo_background: {
    value: 'transparent'
  },
  c_clickable_dangerPseudo_border: {
    value: 'transparent'
  },
  c_clickable_dangerPseudo_text: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_dangerPseudo_hover_background: _objectSpread({}, _rootColors.default._dangerColor100),
  c_clickable_dangerPseudo_hover_border: _objectSpread({}, _rootColors.default._dangerColor100),
  c_clickable_dangerPseudo_hover_text: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_dangerPseudo_active_background: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_dangerPseudo_active_border: _objectSpread({}, _rootColors.default._dangerColor600),
  c_clickable_dangerPseudo_active_text: _objectSpread({}, _rootColors.default._white),
  // checkbox style buttons - unchecked
  c_clickable_checkbox_background: _objectSpread({}, _rootColors.default._white),
  c_clickable_checkbox_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_checkbox_text: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_checkbox_hover_background: _objectSpread({}, _rootColors.default._primaryColor100),
  c_clickable_checkbox_hover_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_checkbox_hover_text: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_checkbox_active_background: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_checkbox_active_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_checkbox_active_text: _objectSpread({}, _rootColors.default._white),
  // checkbox style buttons - checked
  c_clickable_checkboxChecked_background: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_checkboxChecked_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_checkboxChecked_text: _objectSpread({}, _rootColors.default._white),
  c_clickable_checkboxChecked_hover_background: _objectSpread({}, _rootColors.default._primaryColor700),
  c_clickable_checkboxChecked_hover_border: _objectSpread({}, _rootColors.default._primaryColor700),
  c_clickable_checkboxChecked_hover_text: _objectSpread({}, _rootColors.default._white),
  c_clickable_checkboxChecked_active_background: _objectSpread({}, _rootColors.default._primaryColor500),
  c_clickable_checkboxChecked_active_border: _objectSpread({}, _rootColors.default._primaryColor500),
  c_clickable_checkboxChecked_active_text: _objectSpread({}, _rootColors.default._white),
  // links
  c_clickable_link_default: _objectSpread({}, _rootColors.default._primaryColor600),
  c_clickable_link_hover: _objectSpread({}, _rootColors.default._primaryColor700),
  c_clickable_link_active: _objectSpread({}, _rootColors.default._primaryColor500),
  c_clickable_link_disabled: _objectSpread({}, _rootColors.default._greyColor300),
  // this differs from the text for a standard button when disabled, with the intent of keeping readability while conveying intent
  c_clickable_linkOverDark_default: _objectSpread({}, _rootColors.default._white),
  c_clickable_linkOverDark_hover: _objectSpread({}, _rootColors.default._primaryColor200),
  c_clickable_linkOverDark_active: _objectSpread({}, _rootColors.default._primaryColor100),
  c_clickable_linkOverDark_disabled: _objectSpread({}, _rootColors.default._greyColor200),
  // ######################################################## //
  // ## DropDowns and Dropdown Buttons                     ## //
  // ## Similar to buttons but different, thus own section ## //
  // ## Currently only with one theme                      ## //
  // ######################################################## //
  c_dropdown_button_disabled_background: _objectSpread({}, _rootColors.default._greyColor100),
  c_dropdown_button_disabled_border: _objectSpread({}, _rootColors.default._greyColor100),
  c_dropdown_button_disabled_text: _objectSpread({}, _rootColors.default._greyColor600),
  c_dropdown_wrapper_primary_background: _objectSpread({}, _rootColors.default._white),
  c_dropdown_wrapper_primary_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_dropdown_button_primary_background: _objectSpread({}, _rootColors.default._white),
  c_dropdown_button_primary_border: _objectSpread({}, _rootColors.default._primaryColor100),
  c_dropdown_button_primary_text: _objectSpread({}, _rootColors.default._greyColor800),
  c_dropdown_button_primary_hover_background: _objectSpread({}, _rootColors.default._primaryColor300),
  c_dropdown_button_primary_hover_border: _objectSpread({}, _rootColors.default._primaryColor300),
  c_dropdown_button_primary_hover_text: _objectSpread({}, _rootColors.default._greyColor800),
  c_dropdown_button_primary_active_background: _objectSpread({}, _rootColors.default._primaryColor200),
  c_dropdown_button_primary_active_border: _objectSpread({}, _rootColors.default._primaryColor200),
  c_dropdown_button_primary_active_text: _objectSpread({}, _rootColors.default._greyColor800),
  // ######################################################## //
  // ## Card-like Elements (non-interactive containers)    ## //
  // ## Like buttons but with a few exceptions             ## //
  // ######################################################## //
  // default
  c_card_default_background: _objectSpread({}, _rootColors.default._white),
  c_card_default_border: _objectSpread({}, _rootColors.default._greyColor600),
  c_card_default_text: _objectSpread({}, _rootColors.default._greyColor800),
  // primary
  c_card_primary_background: _objectSpread({}, _rootColors.default._primaryColor600),
  c_card_primary_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_card_primary_text: _objectSpread({}, _rootColors.default._white),
  // primaryGhost
  c_card_primaryGhost_background: _objectSpread({}, _rootColors.default._primaryColor100),
  c_card_primaryGhost_border: _objectSpread({}, _rootColors.default._primaryColor600),
  c_card_primaryGhost_text: _objectSpread({}, _rootColors.default._primaryColor600),
  // cta
  c_card_cta_background: _objectSpread({}, _rootColors.default._ctaColor600),
  c_card_cta_border: _objectSpread({}, _rootColors.default._ctaColor600),
  c_card_cta_text: _objectSpread({}, _rootColors.default._white),
  // ctaGhost
  c_card_ctaGhost_background: _objectSpread({}, _rootColors.default._ctaColor100),
  c_card_ctaGhost_border: _objectSpread({}, _rootColors.default._ctaColor600),
  c_card_ctaGhost_text: _objectSpread({}, _rootColors.default._ctaColor600),
  // info
  c_card_info_background: _objectSpread({}, _rootColors.default._infoColor600),
  c_card_info_border: _objectSpread({}, _rootColors.default._infoColor600),
  c_card_info_text: _objectSpread({}, _rootColors.default._white),
  // infoGhost
  c_card_infoGhost_background: _objectSpread({}, _rootColors.default._infoColor100),
  c_card_infoGhost_border: _objectSpread({}, _rootColors.default._infoColor600),
  c_card_infoGhost_text: _objectSpread({}, _rootColors.default._infoColor600),
  // warning
  c_card_warning_background: _objectSpread({}, _rootColors.default._warningColor600),
  c_card_warning_border: _objectSpread({}, _rootColors.default._warningColor600),
  c_card_warning_text: _objectSpread({}, _rootColors.default._greyColor800),
  // warningGhost
  c_card_warningGhost_background: _objectSpread({}, _rootColors.default._warningColor100),
  c_card_warningGhost_border: _objectSpread({}, _rootColors.default._warningColor600),
  c_card_warningGhost_text: _objectSpread({}, _rootColors.default._greyColor800),
  // danger
  c_card_danger_background: _objectSpread({}, _rootColors.default._dangerColor600),
  c_card_danger_border: _objectSpread({}, _rootColors.default._dangerColor600),
  c_card_danger_text: _objectSpread({}, _rootColors.default._white),
  // dangerGhost
  c_card_dangerGhost_background: _objectSpread({}, _rootColors.default._dangerColor100),
  c_card_dangerGhost_border: _objectSpread({}, _rootColors.default._dangerColor600),
  c_card_dangerGhost_text: _objectSpread({}, _rootColors.default._dangerColor600),
  // ###################################### //
  // ## Text/Icon/Foreground elements    ## //
  // ###################################### //
  // text/foreground
  c_foreground_default: _objectSpread({}, _rootColors.default._greyColor800),
  c_foreground_primary: _objectSpread({}, _rootColors.default._primaryColor600),
  c_foreground_primary_medLight: _objectSpread({}, _rootColors.default._primaryColor300),
  c_foreground_cta: _objectSpread({}, _rootColors.default._ctaColor600),
  c_foreground_overDark: _objectSpread({}, _rootColors.default._white),
  c_foreground_info: _objectSpread({}, _rootColors.default._infoColor600),
  c_foreground_warning: _objectSpread({}, _rootColors.default._warningColor600),
  c_foreground_danger: _objectSpread({}, _rootColors.default._dangerColor600),
  c_foreground_disabled: _objectSpread({}, _rootColors.default._greyColor300),
  c_foreground_gridLines: _objectSpread({}, _rootColors.default._greyColor200),
  c_foreground_search_border: _objectSpread({}, _rootColors.default._greyColor600),
  // todo: this is feeling pretty one-off... may want to reconsider
  c_foreground_nav: _objectSpread({}, _rootColors.default._greyColor200),
  // todo: make sure this is what we want to do
  c_foreground_nav_active: _objectSpread({}, _rootColors.default._greyColor100),
  // todo: make sure this is what we want to do
  // ###################################### //
  // ## background elements              ## //
  // ###################################### //
  // brand-associated backgrounds, used for items tied heavily to the brand such as the header - not for things like buttons
  c_background_brand: _objectSpread({}, _rootColors.default._primaryColor600),
  c_background_brand_veryLight: _objectSpread({}, _rootColors.default._primaryColor100),
  // primarily for portal
  // standard background for most (questionnaire) apps
  c_background_default: _objectSpread({}, _rootColors.default._white),
  // used on the portal as its primary background
  c_background_alt: _objectSpread({}, _rootColors.default._greyColor100),
  // backgrounds for things tied to the primary colors
  c_background_primary: _objectSpread({}, _rootColors.default._primaryColor600),
  c_background_primary_veryLight: _objectSpread({}, _rootColors.default._primaryColor100),
  // backgrounds for things tied to the cta colors
  c_background_cta_veryLight: _objectSpread({}, _rootColors.default._ctaColor100),
  // backgrounds for cards/modals/toasts // todo: make this statement accurate
  c_background_info_veryLight: _objectSpread({}, _rootColors.default._infoColor100),
  c_background_warning_veryLight: _objectSpread({}, _rootColors.default._warningColor100),
  c_background_danger_veryLight: _objectSpread({}, _rootColors.default._dangerColor100),
  // background for disabled clickable elements
  c_background_disabled_veryLight: _objectSpread({}, _rootColors.default._greyColor100),
  // background for the progress bar
  c_background_progressBar: _objectSpread({}, _rootColors.default._greyColor200),
  // portal nav currently uses different colors than the standard nav - this may want to be moved into a commonComponentStyles file
  c_background_nav: _objectSpread({}, _rootColors.default._greyColor1000),
  // todo: refactor when the portal menu is updated
  c_background_nav_active: _objectSpread({}, _rootColors.default._greyColor800),
  // todo: refactor when the portal menu is updated
  // dataGrids
  // todo: 1) do we need the special dataGrid color 2) if we need more definitions, break into useMappings or commonComponentStyles file
  c_dataGrid_header_background: _objectSpread({}, _rootColors.default._dataGrid600),
  c_dataGrid_grid_background: _objectSpread({}, _rootColors.default._greyColor100),
  // masks
  c_mask_loader: _objectSpread({}, _rootColors.default._mask100),
  c_mask_modal: _objectSpread({}, _rootColors.default._mask600),
  // Menus - be aware that the subnav should share styling with the dropdown buttons
  c_side_nav: _objectSpread({}, _rootColors.default._primaryColor600),
  c_side_nav_hover: _objectSpread({}, _rootColors.default._primaryColor500),
  c_side_nav_active: _objectSpread({}, _rootColors.default._primaryColor700),
  c_side_nav_sub: _objectSpread({}, _rootColors.default._primaryColor100),
  c_side_nav_sub_hover: _objectSpread({}, _rootColors.default._primaryColor300),
  c_side_nav_sub_active: _objectSpread({}, _rootColors.default._primaryColor200),
  c_side_nav_sub_text: _objectSpread({}, _rootColors.default._primaryColor700),
  // todo: kill/align with standard button patterns once these colors are worked out
  // outside of the CrudListItem DO NO USE THESE COLORS
  accessibleAqua: _objectSpread({}, _rootColors.default._secondaryColor600),
  accessibleAquaHover: _objectSpread({}, _rootColors.default._secondaryColor700)
};
exports.colorMappings = colorMappings;